import axios from 'axios';
import { API_BASE_URL } from '../api';

export const validateInfluencerPromoCode = (code) =>
  axios.get(`${API_BASE_URL}/influencer/validate/${encodeURIComponent(code)}`);

export const getInfluencerDashboard = (token) =>
  axios.get(`${API_BASE_URL}/influencer/dashboard`, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const getInfluencerMe = (token) =>
  axios.get(`${API_BASE_URL}/influencer/me`, {
    headers: { Authorization: `Bearer ${token}` },
  });
